var _g, _linearGradient, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMandate = function SvgMandate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64.8 55.4",
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 6)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9 -6)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "330-a",
    gradientUnits: "userSpaceOnUse",
    x1: -456.52,
    y1: 516.413,
    x2: -456.509,
    y2: 515.418,
    gradientTransform: "matrix(46.77 0 0 -37.43 21383.59 19335.47)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9d9d9c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.8 16.5c0-2.3-1.9-4.2-4.2-4.2h-9.2v-.7c0-2.9-2.2-5.3-5.1-5.6H28c-3.1 0-5.6 2.5-5.6 5.6v.7h-9.2c-2.3 0-4.2 1.9-4.2 4.2V28c.2.1.4.2.5.3v11c0 2.3 1.9 4.2 4.2 4.2H51c2.3 0 4.2-1.9 4.2-4.2v-11c.2-.1.4-.2.5-.3l.1-11.5zm-30.7-4.9c0-1.6 1.3-2.8 2.8-2.8h8.9c1.6 0 2.8 1.3 2.8 2.8v.7H25.1v-.7z",
    fill: "url(#330-a)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M16.1 6.3v-.7c0-1.6 1.3-2.8 2.8-2.8h8.9c1.6 0 2.8 1.3 2.8 2.8v.7h2.8v-.7c0-2.9-2.2-5.3-5.1-5.6H19c-3.1 0-5.6 2.5-5.6 5.6v.7h2.7zM.5 19.1v14.1c0 2.3 1.9 4.2 4.2 4.2H42c2.3 0 4.2-1.9 4.2-4.2V19.1c-5.9 3-13.9 4.9-23.1 4.9S6.5 22.1.5 19.1z",
    style: {
      fill: "#6c718e"
    }
  }), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "330-b",
    gradientUnits: "userSpaceOnUse",
    x1: -465.516,
    y1: 500.072,
    x2: -465.513,
    y2: 498.541,
    gradientTransform: "matrix(46.77 0 0 -20.535 21795.52 10275.122)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59529e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b4382"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 6.3H4.2C1.9 6.3 0 8.2 0 10.5V22c5.9 3 14.2 4.9 23.4 4.9S40.9 25 46.8 22V10.5c-.1-2.3-1.9-4.2-4.3-4.2z",
    fill: "url(#330-b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 6.3H4.2C1.9 6.3 0 8.2 0 10.5V22c5.9 3 14.2 4.9 23.4 4.9S40.9 25 46.8 22V10.5c-.1-2.3-1.9-4.2-4.3-4.2z",
    fill: "#9da0b3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30.1h-2c-.5 0-1-.4-1-1v-5.9c0-.5.4-1 1-1h2c.5 0 1 .4 1 1v5.9c-.1.5-.5 1-1 1z",
    fill: "#cecfd9"
  }))));
};
export default SvgMandate;